export const localStorageKeys = {
    authToken: 'authToken',
    visitorEvents: 'visitorEvents',
    visitorPlaces: 'visitorPlaces',
    visitorTrip: 'visitorTrip',
    visitorSettings: 'visitorSettings',
    allFrontendSettings: 'allFrontendSettings',
    allBackendSettings:'allBackendSettings',
    allFrontendSettingsForTP:'allFrontendSettingsForTP',
    timezoneFormatterDefault:'timezoneFormatterDefault',
    tripPlannerLoadingTip: 'tripPlannerLoadingTip',
    googlePlaceTypeToPull: 'googlePlaceTypeToPull',
    googlePlaceTypeToPullForAreaBusiness: 'googlePlaceTypeToPullForAreaBusiness',
    googlePlaceTypeToPullForLocalSecrets: 'googlePlaceTypeToPullForLocalSecrets',
    eventQueryCommand: 'eventQueryCommand',
    selectedPlaceCategory: 'selectedPlaceCategory',
    GDPRAcceptCookie: 'GDPRAcceptCookie',
    allowedPlaceCategories: 'allowedPlaceCategories',
    doNotShowRemoveSuccessfullyModal: 'doNotShowRemoveSuccessfullyModal'
};


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/constants/local.storage.keys.ts